// store.js
import { configureStore } from '@reduxjs/toolkit';
import { tasksApi } from './services/tasksApi';
import { usersApi } from './services/usersApi';
import { authApi } from './services/authApi';
import { websocketApi } from './services/websocketApi.ts';
import authReducer from "./features/authSlice";
import backendReducer from './features/backendSlice';
import websocketReducer from './features/websocketSlice';
import globalReducer from './features/globalSlice.ts';
import { InstitutionsApi } from './services/institutionsApi.js';
import { toastsApi } from "./services/toastsApi";
import { viewsApi } from './services/viewsApi.js';
import { configApi } from './services/configApi.js';


export const store = configureStore({
  reducer: {
    global: globalReducer,
    [tasksApi.reducerPath]: tasksApi.reducer,
    [usersApi.reducerPath]: usersApi.reducer,
    [InstitutionsApi.reducerPath]: InstitutionsApi.reducer,
    [authApi.reducerPath]: authApi.reducer,
    [websocketApi.reducerPath]: websocketApi.reducer,
    [toastsApi.reducerPath]: toastsApi.reducer,
    [viewsApi.reducerPath]: viewsApi.reducer,
    [configApi.reducerPath]: configApi.reducer,
    auth: authReducer,
    backend: backendReducer,
    websocket: websocketReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      tasksApi.middleware,
      usersApi.middleware,
      authApi.middleware,
      websocketApi.middleware,
      toastsApi.middleware,
      InstitutionsApi.middleware,
      viewsApi.middleware,
      configApi.middleware
    ),
});
